<template lang="pug">
  div.shipper-type
    icon-delivery(v-if="'delivery' === type" @clicked="clicked")
    icon-pickup(v-else-if="'pickup' === type" @clicked="clicked")
</template>
<script>
  import IconPickup from './icons/IconPickup'
  import IconDelivery from './icons/IconDelivery'
  import {bus} from "../main";
  export default {
    name: 'Shipper',
    components:{
      IconPickup,
      IconDelivery,
    },
    props:['type'],
    methods: {
      clicked () {
        bus.$emit('openShipmentSelector');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Shipper.vue